import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path d='M8 4V9V4Z' fill='currentColor' />
        <path
            d='M8 4V9'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M8.33333 12C8.33333 12.1841 8.18411 12.3333 8 12.3333C7.81589 12.3333 7.66667 12.1841 7.66667 12C7.66667 11.8159 7.81589 11.6667 8 11.6667C8.18411 11.6667 8.33333 11.8159 8.33333 12Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='1.33333'
        />
    </svg>
);

export const ExclamationIcon = styled(Icon)({});
